import {useEffect, useState} from "react";
// import {NavLink as ReactLink} from 'react-router-dom';
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import {useTranslation} from "react-i18next";
import useAnimation from "../../utils/hooks/animate";

export const OtherTasks = () => {
    const [tabId, setTabId] = useState<string>("1");
    const {t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: "tasks"});
    }, [t]);

    return (
        <main className="pt-2">
            <Nav tabs>
                <NavItem>
                    <NavLink className={`other ${tabId === "1" ? "active" : ""}`} onClick={e => setTabId("1")}>Task 1</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={`other ${tabId === "2" ? "active" : ""}`} onClick={e => setTabId("2")}>Task 2</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={`other ${tabId === "3" ? "active" : ""}`} onClick={e => setTabId("3")}>Task 3</NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={tabId}>
                <TabPane tabId="1">
                    <section>
                        <p className="text-center animated">{t("other.tasks.1.s1.1")}</p>
                        <ul className="list-group">
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.1.s1.2")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.1.s1.3")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.1.s1.4")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.1.s1.5")}</p></li>
                        </ul>
                    </section>
                    <section>
                        <p className="animated">{t("other.tasks.1.s2.1")}</p>
                        <p className="animated">{t("other.tasks.1.s2.2")}</p>
                        <p className="animated">{t("other.tasks.1.s2.3")}</p>
                        <p className="animated">{t("other.tasks.1.s2.4")}</p>
                    </section>
                    <section>
                        <p className="text-center animated">{t("other.tasks.1.s3.1")}</p>
                        <ul className="list-group">
                            {[2, 3, 4, 5, 6].map((item, i) => (
                                <li key={i} className="list-group-item bg-light">
                                    <p className="animated">{t("other.tasks.1.s3." + item + ".text")}<span> </span>
                                        <a target="_blank" rel="noreferrer" href={t("other.tasks.1.s3." + item + ".link")}>{t("other.tasks.video")}</a>
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </section>
                </TabPane>
                <TabPane tabId="2">
                    <section>
                        <p className="text-center animated">{t("other.tasks.2.s1.1")}</p>
                        <ul className="list-group">
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.2.s1.2")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.2.s1.3")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.2.s1.4")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.2.s1.5")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.2.s1.6")}</p></li>
                        </ul>
                    </section>
                    <section>
                        <p className="animated">{t("other.tasks.2.s2.1")}</p>
                        <p className="animated">{t("other.tasks.2.s2.2")}</p>
                        <p className="animated">{t("other.tasks.2.s2.3")}</p>
                    </section>
                    <section>
                        <p className="text-center animated">{t("other.tasks.2.s3.1")}</p>
                        <ul className="list-group">
                            {[2, 3, 4].map((item, i) => (
                                <li key={i} className="list-group-item bg-light">
                                    <p className="animated">{t("other.tasks.2.s3." + item + ".text")}<span> </span>
                                        <a target="_blank" rel="noreferrer" href={t("other.tasks.2.s3." + item + ".link")}>{t("other.tasks.video")}</a>
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </section>
                </TabPane>
                <TabPane tabId="3">
                    <section>
                        <p className="text-center animated">{t("other.tasks.3.s1.1")}</p>
                        <ul className="list-group">
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.3.s1.2")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.3.s1.3")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.3.s1.4")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.3.s1.5")}</p></li>
                            <li className="list-group-item bg-light"><p className="animated">{t("other.tasks.3.s1.6")}</p></li>
                        </ul>
                    </section>
                    <section>
                        <p className="animated">{t("other.tasks.3.s2.1")}</p>
                        <p className="animated">{t("other.tasks.3.s2.2")}</p>
                        <p className="animated">{t("other.tasks.3.s2.3")}</p>
                    </section>
                    <section>
                        <p className="text-center animated">{t("other.tasks.3.s3.1")}</p>
                        <ul className="list-group">
                            {[2, 3, 4, 5].map((item, i) => (
                                <li key={i} className="list-group-item bg-light">
                                    <p className="animated">{t("other.tasks.3.s3." + item + ".text")}<span> </span>
                                        <a target="_blank" rel="noreferrer" href={t("other.tasks.3.s3." + item + ".link")}>{t("other.tasks.video")}</a>
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </section>
                </TabPane>
            </TabContent>
        </main>
    );
};